import { Fragment, FunctionComponent, useState } from "react";
import {
  StyledTab,
  StyledTabs,
  StyledTabsContainer,
  StyledTabsHeader,
} from "./tabs.styles";
import { TabInterface } from "./interfaces";
import { read, write } from "lib/storage";

export interface TabsProps {
  name: string;
  tabs: TabInterface[];
}

const Tabs: FunctionComponent<TabsProps> = ({ name, tabs }) => {
  const tabsKey = `tabs-${name}`;
  const [activeKey, toggleActiveKey] = useState(
    read<string>(tabsKey) || tabs[0].key,
  );

  const switchTo = (key: string) => {
    toggleActiveKey(key);
    write(tabsKey, key);
  };

  return (
    <StyledTabs>
      <StyledTabsHeader>
        {tabs.map((tab) => {
          const { key, disabled = false } = tab;
          return (
            <StyledTab
              $active={activeKey === key}
              key={key}
              $disabled={disabled}
              onClick={disabled ? undefined : () => switchTo(tab.key)}
            >
              {tab.label}
            </StyledTab>
          );
        })}
      </StyledTabsHeader>
      <StyledTabsContainer>
        {tabs.map((tab) => {
          if (tab.key === activeKey) {
            return <Fragment key={tab.key}>{tab.render()}</Fragment>;
          }
          return null;
        })}
      </StyledTabsContainer>
    </StyledTabs>
  );
};

export default Tabs;
